import { TEMPORARY_ID_PREFIX } from '@/constants/PREFIX.ts'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { STORY_TYPES } from '@/constants/STORY_TYPES.ts'
import { ONE_WEEK } from '@/utils/date.ts'
import { getTemporaryId } from '@/utils/key.ts'

export const DEFAULT_MEMBER: Member = {
  id: '',
  name: '',
}

export const DEFAULT_STORY = (id?: string): Story | Omit<Story, 'id'> => ({
  id,
  title: '',
  description: '',
  status: STORY_STATUSES.UNSCHEDULED,
  storyType: STORY_TYPES.FEATURE,
  estimate: -1,
  requestedBy: DEFAULT_MEMBER,
  owners: [],
  comments: [],
  tasks: [],
  blockers: [],
  labels: [],
  deadline: null,
  acceptedAt: null,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  afterId: null,
  beforeId: null,
  iterationNumber: null,
  blockedStoryIds: [],
  subgroup: null,
})

export const DEFAULT_COMMENT = (storyId: string, user = DEFAULT_MEMBER, id?: string): StoryComment => ({
  id: id ?? getTemporaryId(),
  storyId,
  user,
  content: '',
  createdAt: new Date().getTime(),
  updatedAt: new Date().getTime(),
  attachments: [],
})

export const DEFAULT_TASK = (storyId: string, afterId: string | null, id?: string): Task => ({
  id: id ?? getTemporaryId(),
  storyId,
  title: '',
  finished: false,
  afterId,
  beforeId: null,
})

export const DEFAULT_BLOCKER = (storyId: string, id?: string): Blocker => ({
  id: id ?? getTemporaryId(),
  storyId,
  description: '',
  resolved: false,
  createdAt: new Date().getTime(),
})

export const DEFAULT_ITERATION = (projectId: string): Iteration => ({
  number: 1,
  start: new Date().getTime(),
  finish: new Date().getTime() + ONE_WEEK,
  teamStrength: 1,
  velocity: 10,
  projectId,
})

export const NEW_STORY_ID = `${TEMPORARY_ID_PREFIX}1`
